import React  from 'react';
import PropTypes from 'prop-types';
import { shadeColor } from '../../themes/Colors';
import { pink } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';
import { Route } from 'react-router-dom';
import { ADD_ENTRY, ADD_POST, ENTRY, LOG, POST } from '../../constants/routing';
import AddPost from '../../pages/AddPost';
import AddEntry from '../../pages/AddEntry';
import Post from '../../pages/Post';
import Entry from '../../pages/Entry';
import LogPage from '../LogPage';

const Log = props => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Route exact path={LOG} component={LogPage} />
        <Route exact path={POST} component={Post} />
        <Route exact path={ADD_POST} component={AddPost} />
        <Route exact path={ADD_ENTRY} component={AddEntry} />
        <Route exact path={ENTRY} component={Entry} />
      </div>
    </div>
  );
};

Log.propTypes = {

};

const useStyles = makeStyles(
  theme => {
    return {
      root: {
        backgroundColor: shadeColor(pink[50], 10),
        minHeight: '100vh',
        width: '100%',
        maxWidth: '100%',
        display: 'flex',
      },
      container: {
        position: 'relative',
        // maxWidth: 1400,
        width: '100%',
        margin: 'auto'
      }
    };
  }
);

export default Log;
